import Vue from 'vue'
import Vuex from 'vuex'

import user from './module/user'
import app from './module/app'
import enginebrandserv from './module/enginebrandserv'
import favoritevehicleserv from './module/favoritevehicleserv'
import pictureserv from './module/pictureserv'
import vehiclebrandserv from './module/vehiclebrandserv'
import vehicleinfoserv from './module/vehicleinfoserv'
import vehiclemodelserv from './module/vehiclemodelserv'
import vehicleownerinfoserv from './module/vehicleownerinfoserv'
import vehicletypeserv from './module/vehicletypeserv'
import accountexserv from './module/accountexserv'
import clientserv from './module/clientserv'
import clientinfoserv from './module/clientinfoserv'
import peccancyrecordserv from './module/peccancyrecordserv'
import remindserv from './module/remindserv'
import transportvehicleinfoserv from './module/transportvehicleinfoserv'
import transportvehicleinfogroupserv from './module/transportvehicleinfogroupserv'
import mediaplatformserv from './module/mediaplatformserv'
import webadminerrorlogserv from './module/webadminerrorlogserv'
import roleserv from './module/roleserv'
import usergroupserv from './module/usergroupserv'
import accountserv from './module/accountserv'
import webtablecolumnsserv from './module/webtablecolumnsserv'
import permissionserv from './module/permissionserv'
import userserv from './module/userserv'
import systemlogserv from './module/systemlogserv'
import backupdbserv from './module/backupdbserv'
import systeminfoserv from './module/systeminfoserv'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    //
  },
  mutations: {
    //
  },
  actions: {
    //
  },
  modules: {
    user,
    app,
    enginebrandserv,
    favoritevehicleserv,
    pictureserv,
    vehiclebrandserv,
    vehicleinfoserv,
    vehiclemodelserv,
    vehicleownerinfoserv,
    vehicletypeserv,
    accountexserv,
    clientserv,
    clientinfoserv,
    peccancyrecordserv,
    remindserv,
    transportvehicleinfoserv,
    transportvehicleinfogroupserv,
    mediaplatformserv,
    webadminerrorlogserv,
    roleserv,
    usergroupserv,
    accountserv,
    webtablecolumnsserv,
    permissionserv,
    userserv,
    systemlogserv,
    backupdbserv,
    systeminfoserv,
  }
})